import common from './common';
import siteMetadata from './site-metadata';
import home from './home';
import about from './about';
import blog from './blog';
import onlineWills from './online-wills';
import guard from './guardianship';
import epa from './epa';
import estateSession from './estate-session';
import storage from './storage';
import pricing from './pricing';
import contact from './contact';
import charities from './charities';
import comparison from './comparison';
import whichWill from './which-will';
import countrySpecificWills from './country-specific-wills';
import questions from './questions';
import premium from './premium';
import partnerships from './partnerships';
import faq from './faq';
import newHome from './new-home';

export default {
    ...common,
    ...siteMetadata,
    ...home,
    ...about,
    ...blog,
    ...onlineWills,
    ...guard,
    ...epa,
    ...estateSession,
    ...storage,
    ...pricing,
    ...contact,
    ...charities,
    ...comparison,
    ...whichWill,
    ...countrySpecificWills,
    ...questions,
    ...premium,
    ...partnerships,
    ...faq,
    ...newHome,
};
